module.exports = __webpack_public_path__ + "static/img/egg_b_22.7aed000.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/eggs/b/egg_b_22.png
// module id = 17uk
// module chunks = 1